import React, { useContext, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Checkin from './components/CheckIn/CheckInImpl';
import WhoAreYou from './components/WhoAreYou/WhoAreYouImpl';
import HttpServiceImpl from './services/Http/HttpServiceImpl';
import TrainingVerified from './components/TrainingVerified/TrainingVerifiedImpl';
import TrainingOutofDate from './components/TrainingOutofDate/TrainingOutofDateImpl';
import { CompanyDataProvider } from './context/CompanyDataContext';
import {
  TraineeDataProvider,
  TraineeDataContext,
} from './context/TraineeDataContext';

import './styles.scss';

export const useTraineeData = () => useContext(TraineeDataContext);
const apiEnv: string = process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT || '';
let apiSuffix = '';
if (apiEnv !== 'prod') {
  apiSuffix = '/test';
}
const api: string = process.env.REACT_APP_API_URL + apiSuffix || '';

const App: React.FC = () => {
  // ───────────────────────────────────────────────────────────
  // 1) Version polling logic (#5)
  // ───────────────────────────────────────────────────────────
  const CURRENT_VERSION = process.env.REACT_APP_VERSION;
  const versionRef = useRef(CURRENT_VERSION);

//   useEffect(() => {
//     const interval = setInterval(async () => {
//       try {
//         const res = await fetch('/meta.json', { cache: 'no-cache' });
//         if (!res.ok) throw new Error(res.statusText);
//         const { version } = await res.json();
//         if (version !== versionRef.current) {
//           window.location.reload();
//         }
//       } catch (e) {
//         console.error('Version check failed:', e);
//       }
//     }, 60_000); // every minute

//     return () => clearInterval(interval);
//   }, []);
  // ───────────────────────────────────────────────────────────

  const tervurenAPI = new HttpServiceImpl(api);

  return (
    <Router>
      <CompanyDataProvider>
        <TraineeDataProvider>
          <Routes>
            <Route
              path="/checkin/:companyId/:regionId/:locationId"
              element={<Checkin httpService={tervurenAPI} />}
            />
            <Route
              path="/who-are-you/:companyId/:regionId/:locationId"
              element={<WhoAreYou httpService={tervurenAPI} />}
            />
            <Route
              path="/training-out-of-date/:companyId/:regionId/:locationId"
              element={<TrainingOutofDate />}
            />

            <Route
              path="/training-verified/:companyId/:regionId/:locationId"
              element={<TrainingVerified httpService={tervurenAPI} />}
            />
          </Routes>
        </TraineeDataProvider>
      </CompanyDataProvider>
    </Router>
  );
};

export default App;
